import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/offer';
const FIRST_DELAY = 12000;
const INTERVAL = 150000; // 2 minuti e 30 secondi
const VISIBLE_FOR = 6000;
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    let hideTimer: number | undefined;
    const show = () => {
      setVisible(true);
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % purchaseNotifications.length);
      }, VISIBLE_FOR);
    };
    let interval: number | undefined;
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const n = purchaseNotifications[index];
  return <div className="pointer-events-none fixed inset-x-0 bottom-24 z-50 mx-auto w-full max-w-[480px] px-3" data-id="element-240" data-mp="1z7ox4qnp038o">
      <AnimatePresence data-id="element-241" data-mp="235cyocjw4u9j">
        {visible && <motion.div key={index} role="status" initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border border-ivory-line bg-ivory-white p-3 pr-2 shadow-frame" data-id="element-242" data-mp="2857pkg3o1jul">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-leaf" data-id="element-243" data-mp="rqzf3jw670zb">
              <CheckIcon className="h-5 w-5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-244" data-mp="wpsslcbgirzh" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-245" data-mp="200gbxico0cmw">
              <p className="truncate text-sm text-ink" data-id="element-246" data-mp="1v36f3hmy4yp1">
                <span className="font-semibold" data-id="element-247" data-mp="1v2erou3i679u">
                  {n.name} da {n.city}
                </span>{' '}
                ha appena acquistato
              </p>
              <p className="truncate text-xs text-ink-muted" data-id="element-248" data-mp="24shnt35x81ce">Flauto Master + 5 bonus · {n.ago}</p>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Chiudi notifica" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-ink-muted transition-colors duration-150 hover:bg-ivory-2 hover:text-ink" data-id="element-249" data-mp="1h3yeqlf1rkj9">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="1l3fjtdqkafnw" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}